import React, { useState, useEffect } from 'react';
import styles from './templateStyle.module.css';
import { Text } from '../Text';
import { ReactComponent as PreviewHeader } from '../../assets/new_preview_header.svg';
import { ReactComponent as PreviewFooter } from '../../assets/new_preview_footer.svg';
import MarketingStandardPreview from './MarketingStandardPreview';
import MarketingCarouselPreview from './MarketingCarouselPreview';
import MarketingProductPreview from './MarketingProductPreview';
import UtilityCallPermissionPreview from './UtilityCallPermissionPreview';
import AuthenticationPreview from './AuthenticationPreview';
const TemplatePreview = ({
  header = '',
  content = '',
  file = null,
  videoPreview = null,
  documentPreview = null,
  imagePreview = null,
  footer = '',
  buttons = [],

  category,
  messageType,

  carouselType,
  carouselCards = [],

  productCards = [],
  productCTAType,
  productCTA,
  productType,
  productThumbnail,
  watch,
}) => {
  const PreviewComponentMap = {
    MARKETING_STANDARD: MarketingStandardPreview,
    UTILITY_STANDARD: MarketingStandardPreview,
    MARKETING_CAROUSEL: MarketingCarouselPreview,
    MARKETING_PRODUCT: MarketingProductPreview,
    MARKETING_CALL_PERMISSION: UtilityCallPermissionPreview,
    UTILITY_CALL_PERMISSION: UtilityCallPermissionPreview,
    AUTHENTICATION: AuthenticationPreview,
  };

  const previewKey =
    category === 'AUTHENTICATION' ? 'AUTHENTICATION' : `${category}_${messageType}`;
  const PreviewComponent = PreviewComponentMap[previewKey];

  const commonProps = {
    header,
    content,
    footer,
    file,
    imagePreview,
    videoPreview,
    documentPreview,
    buttons,
    styles,

    carouselType,
    carouselCards,
    productCards,
    productCTAType,
    productCTA,

    productType,
    productThumbnail,

    securityDisclaimer: watch?.('securityDisclaimer'),
    expirationWarning: watch?.('expirationWarning'),
    authCTA: watch?.('authCTA'),
  };

  return (
    <div className={` flex flex-column justify-content-end gap-2`}>
      <div className={` flex flex-column ${styles['mobile-preview']}`}>
        <div className={`flex ${styles['logo-container']}`}>
          <PreviewHeader className="w-full h-full" />
        </div>

        {PreviewComponent && <PreviewComponent {...commonProps} />}

        {/* 🔼 Arrow Toggle Button */}
      </div>
    </div>
  );
};

export default TemplatePreview;
